export default __webpack_public_path__ + "assets/pretty-social.f1f056e2.svg";